export default "__VITE_ASSET__gxVeArG1__"